import { menuGroup, menuItem } from "modules/helpers";

// components
import Table from "./Table.doc";
import TableColumn from "./TableColumn.doc";
import TableMenu from "./TableMenu.doc";
import TableMenuItem from "./TableMenuItem.doc";
import TableSelectableColumn from "./TableSelectableColumn.doc";

const components = [
  menuItem("<Table/>", "table", Table),
  menuItem("<Table.Column/>", "table-column", TableColumn),
  menuItem("<Table.Menu/>", "table-menu", TableMenu),
  menuItem("<Table.MenuItem/>", "table-menu-item", TableMenuItem),
  menuItem(
    "<Table.SelectableColumn/>",
    "table-selectable-column",
    TableSelectableColumn
  ),
];

export default [menuGroup("Components", "components", components)];
